import { Country } from '~/Api/Country';
import Product from '~/Api/Product/Product';

export enum Type {
	czech = 'czech',
	referenced = 'referenced',
	other = 'other',
}

export interface ProductGroup {
	type: Type;
	country: Country;
}

export default function resolveProductGroup(product: Product, referenceCountries: Country[]): ProductGroup {
	const { country } = product.dataset.source;

	if (country.alpha2 === 'CZ') {
		return { type: Type.czech, country };
	}

	const referenceCountry = referenceCountries.find((referenceCountry) => referenceCountry.alpha2 === country.alpha2);
	if (referenceCountry !== undefined) {
		return { type: Type.referenced, country: referenceCountry };
	}

	return { type: Type.other, country };
}
